import { HomePage } from "../pages/HomePage"
import { NotFoundPage } from "../pages/NotFoundPage"
import React from "react"

export const viewMap = {
    home: <HomePage />,
    notFound: <NotFoundPage />,
}
